import {
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_ERROR
} from '../actions/roles'

const initialState = {
  items: null,
  error: null,
  loading: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_ROLES_SUCCESS:
      return { ...state, items: (action||{}).data }
    case FETCH_ROLES_ERROR:
      return { ...state, error: action.message }
    default:
      return state
  }
}